import Page from '@/components/common/page';
import HomeQuotes from './home-quotes';
import HomeReviews from './home-reviews';
import HomeFeature from "./home-feature";
import HomeResults from './home-results';
import { initializeHomeCarousels } from '../swiper/swiper'

class HomePage extends Page {
    init() {
        this.quotes = new HomeQuotes;
        this.reviews = new HomeReviews;
        this.HomeFeature = new HomeFeature;
        this.HomeResults = new HomeResults;

        initializeHomeCarousels()
    }
}

export default HomePage;
